<template>
  <div id="app" style="-webkit-print-color-adjust: exact !important;" class="mb-5">
    <Navbar></Navbar>
    <loader v-if="loaderShow"></loader>
    <div v-if="!loaderShow">
      <div class="row  justify-content-end" style="max-width: 100vw">
        <!-- <i
          @click="RoutBack"
          class="cursor-pointer text-left mt-4 fas col-sm-12 col-md-8 fa-3x fa-arrow-left"
        ></i> -->
        <button @click="downloadPdf" class="col-md-2 col-sm-4 downloadButton mr-5 mt-4">Download Report</button>
      </div>
      <div class="pt-5" style="max-width: 100vw">
        <div v-if="data['variables_info']&&data['variables_info']['overall_info']">
          <div class="row justify-content-around max-width">
            <h5 class="font-size mb-5 border-bottom col-11 text-left">Overall Data Info</h5>
          </div>
          <div class>
            <div class="overall_info table-responsive px-5 scrollb">
              <table class="table table-bordered table-hover mb-0">
                <thead>
                  <tr class="tableHeading thead">
                    <th id="splitCell" class="one">
                      <div id="titleDay">Value</div>
                      <div id="titleTime">key</div>
                    </th>
                    <th v-for="(key, i) in row_values" :key="i">{{key}}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(key, j) in variables_keys" :key="j" :class="[(j+1)%2 == 0 ? 'background': '']">
                    <td>{{key}}</td>
                    <td
                      v-for="(colkey, k) in row_values"
                      :key="k"
                    >{{getFixedValue(data['variables_info']['overall_info'][key][colkey])}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="mt-5 pt-5" v-if="data['missing_values_report']">
          <div class="row justify-content-around max-width">
            <h5 class="font-size mb-5 border-bottom col-11 text-left">Missing Values Report</h5>
          </div>
          <div class="table-responsive px-5 scrollb">
            <table class="table table-bordered table-hover mb-0">
              <thead>
                <tr class="tableHeading thead ">
                  <th id="splitCell" class="three">
                    <div id="titleDay">Value</div>
                    <div id="titleTime">key</div>
                  </th>
                  <th v-for="(key, i) in missing_rows" :key="i">{{key}}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(key, j) in missing_keys" :key="j" :class="[(j+1)%2 == 0 ? 'background': '']">
                  <td>{{key}}</td>
                  <td
                    v-for="(keycol, i) in missing_rows"
                    :key="i"
                  >{{getFixedValue(data['missing_values_report'][key][keycol])}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="mt-5 pt-5" v-if="data['outlier_report']">
          <div class="row justify-content-around max-width">
            <h5 class="font-size mb-5 border-bottom col-11 text-left">Outlier Report</h5>
          </div>
          <div class="table-responsive px-5 scrollb">
            <table class="table table-bordered table-hover mb-0">
              <thead>
                <tr class="tableHeading thead">
                  <th id="splitCell" class="three">
                    <div id="titleDay">Value</div>
                    <div id="titleTime">key</div>
                  </th>
                  <th v-for="(key, i) in outlier_rows" :key="i">{{key}}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(key, j) in outlier_keys" :key="j" :class="[(j+1)%2 == 0 ? 'background': '']">
                  <td>{{key}}</td>
                  <td
                    v-for="(keycol, i) in outlier_rows"
                    :key="i"
                  >{{getFixedValue(data['outlier_report'][key][keycol])}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div
          class="mt-5 pt-5"
          v-if="data['anamolies_report']&&Object.keys(data['anamolies_report']).length"
        >
          <div>
            <div class="row justify-content-around max-width">
              <h5 class="font-size mb-5 border-bottom col-8 text-left">Anamolies Report</h5>
            </div>
            <div class="table-responsive px-5">
              <table class="table table-bordered table-hover mb-0">
                <thead>
                  <th></th>
                  <th v-for="key in allKeysforAnamolies" :key="key">{{key}}</th>
                </thead>
                <tbody>
                  <tr v-for="row in anamoliesRows" :key="row">
                    <td>{{row}}</td>
                    <td
                      v-for="key in allKeysforAnamolies"
                      :key="key"
                    >{{data['anamolies_report'][row][key] ? data['anamolies_report'][row][key] : 'N/A'}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import Swal from 'sweetalert2';
// import * as jsPDF from 'jspdf'
import Toasted from "vue-toasted";
import Vue from "vue";
// import $ from "jquery";
// import _ from 'underscore'
// import moment from "moment";
// import { AUTH_LOGOUT } from '../store/actions/auth'
import { apiCall } from "@/utils/api";
import loader from "../loader";
import Navbar from "../navbar";
// import html2pdf from 'html2pdf'

Vue.use(Toasted);

export default {
  name: "Report",
  components: {
    loader: loader,
    Navbar: Navbar
  },
  data() {
    return {
      dataCome: [],
      anamoliesRows: [],
      allKeysforAnamolies: [],
      loaderShow: true,
      visualId: "",
      data: {},
      outlier_keys: [],
      outlier_rows: [
        "outlier_threshold",
        "percentage_of_outliers",
        "total_number_of_outliers"
      ],
      missing_rows: [
        "filling_method",
        "percentage_of_missing_values",
        "total_number_of_missing_values"
      ],
      missing_keys: [],
      variables_keys: [],
      row_values: ["25%", "50%", "75%", "count", "max", "mean", "min", "std"],
      alllFeature: {
        variables_info: "Variables Info",
        missing_values_report: "Missing Values Report",
        outlier_report: "Outlier Report"
      }
    };
  },
  watch: {},
  mounted() {
    this.visualId = this.$route.params.id;
    this.getData(this.visualId);
  },
  computed: {},
  methods: {
    downloadPdf() {
      let printContents, popupWin;
      printContents = document.getElementById("app").innerHTML;
      popupWin = window.open(
        "",
        "_blank",
        "top=0,left=0,height=100%,width=auto"
      );
      popupWin.document.open();
      popupWin.document.write(`
          <html>
            <head>
            <link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/4.1.3/css/bootstrap.min.css" integrity="sha384-MCw98/SFnGE8fJT3GXwEOngsV7Zt27NXFoaoApmYm81iuXoPkFOJwJ8ERdknLPMO" crossorigin="anonymous">
            </head>
            <style>
            @media print {
                .overall_info {
                    overflow: visible !important;
                }
                .downloadButton{
                    display: none;
                }
                }
            </style>
        <body onload="window.print();window.close()">${printContents}</body>
          </html>`);
      popupWin.document.close();
    },
    getFixedValue(value) {
      if (isNaN(value)) {
        return value;
      } else {
        return value.toFixed(3);
      }
    },
    RoutBack() {
      this.$router.push("/visualize");
    },
    getData(id) {
      var ths = this;
      const url = `visual_ml/${id}`;
      apiCall({ url, method: "get" })
        .then(resp => {
          let dataCome = JSON.parse(resp.data)
          this.dataCome = dataCome
          this.data = dataCome
          if (dataCome["anamolies_report"]) {
            ths.anamoliesRows = Object.keys(dataCome["anamolies_report"]);
          }
          if (dataCome["list_of_anamolies"]) {
            dataCome["list_of_anamolies"].map(dat => {
              ths.allKeysforAnamolies.push(dat);
            });
          }
          if (dataCome["variables_info"] && dataCome["variables_info"]["overall_info"]) {
            ths.variables_keys = Object.keys(
              dataCome["variables_info"]["overall_info"]
            );
          }
          if (dataCome["missing_values_report"]) {
            ths.missing_keys = Object.keys(dataCome["missing_values_report"]);
          }
          if (dataCome["outlier_report"]) {
            ths.outlier_keys = Object.keys(dataCome["outlier_report"]);
          }
          this.loaderShow = false
        })
        .catch(err => {
          console.log("error", err);
        });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
svg {
      width: 100%;
      height: 30%;
   }
   line {
         stroke: black;
         stroke-width: 2;
      }
.two {
  background: linear-gradient(to left bottom, #5e9ea0 50%, #ffffff 50%);
}
.one {
  background: linear-gradient(to left bottom, #5e9ea0 50%, #ffffff 50%);
}
.three {
  background: linear-gradient(to left bottom, #5e9ea0 50%, #ffffff 50%);
}
#splitCell {
  margin: 0;
  padding:0;
  position: relative;
}
#titleDay {
  position: absolute;
  top: 6px;
  right: 10px;
  margin: 0;
  padding: 0;
}
#titleTime {
  position: absolute;
  color: black;
  bottom: 6px;
  left: 10px;
  margin: 0;
  padding: 0;
}
.thead {
  background: cadetblue;
  color: white;
}
.background{
  background: #dee2e6;
}
.downloadButton {
  width: 9rem;
  height: 3rem;
  border: none;
  color: white;
  background: cadetblue;
  border-radius: 20px;
}
@media print {
  .overall_info {
    overflow: visible !important;
  }
}
.font-size {
  font-size: 2.5rem;
}
.cursor-pointer {
  cursor: pointer;
}
.max-width {
  max-width: 100vw !important;
}
.scrollb::-webkit-scrollbar {
  display: none;
}
.widthH {
  width: 36% !important;
}
.cursor-pointer {
  cursor: pointer;
}
.line-height {
  line-height: 2rem;
}
.widthCorelation {
  width: 50%;
}
</style>
